"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var DropdownSelect_vue_1 = __importDefault(require("./DropdownSelect.vue"));
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var __ = window.$lang;
var DistrictSelect = /** @class */ (function (_super) {
    __extends(DistrictSelect, _super);
    function DistrictSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "district-select";
        return _this;
    }
    DistrictSelect.prototype.getComputedOptions = function () {
        return this.allDistrictsOption
            ? __spreadArrays([{ value: 0, name: __("Wszystkie hufce") }], this.options) : this.options;
    };
    DistrictSelect.prototype.onDistrictChange = function (option) {
        this.$emit("change", option);
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], DistrictSelect.prototype, "options", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], DistrictSelect.prototype, "currentOption", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], DistrictSelect.prototype, "allDistrictsOption", void 0);
    DistrictSelect = __decorate([
        vue_class_component_1.default({ components: {
                DropdownSelect: DropdownSelect_vue_1.default
            } })
    ], DistrictSelect);
    return DistrictSelect;
}(vue_1.default));
exports.default = DistrictSelect;
